export default "__VITE_ASSET__4Ch1WyPX__"